import { Button } from '@devrangex/rui'
import styled from '@emotion/styled'
import { MouseEventHandler, useMemo } from 'react'
import QRCode from 'react-qr-code'


type QrBoardType = {
  visible: boolean
  onClose: () => void
  machineName?: string
  loginCode?: string
}

const QrBoardContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: #00000099;
  z-index: 999;
`

const QrBoardBox = styled.div`
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  width: 718px;
  height: 920px;
  background: rgba(35, 40, 48, 0.3);
  backdrop-filter: blur(12px);
`

const QrBoardTitle = styled.header`
  margin-bottom: 60px;

  h1 {
    ${({theme}) => theme.font.large}
    color: ${({theme}) => theme.bay.private};
    margin-bottom: 10px;
  }
`

const QrBoardContents = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
`

const QrCodeBackground = styled.div`
  width: 320px;
  height: 320px;
  background-color: ${({theme}) => theme.pallete.white};
  padding: 40px;
`

const NumberCodeBackground = styled.h1`
  background-color: #0e0e0f;
  width: 320px;
  padding: 14px 0;
  margin-bottom: 60px;
`

export default function QrBoard({
  visible,
  loginCode,
  machineName,
  onClose,
}: QrBoardType) {
  const loginCodeNumber = useMemo(() => {
    if (!loginCode) return null

    return `${loginCode.slice(0, 3)} ${loginCode.slice(3, 6)}`
  }, [loginCode])

  if (!visible) return <></>

  const loginCodeForQr = 'nigoltrams' + '|' + loginCode

  const onClickBackground: MouseEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault()

    if (e.target === e.currentTarget) onClose()
  }

  return (
    <QrBoardContainer onClick={onClickBackground} data-testid="qr-board">
      <QrBoardBox>
        <QrBoardContents>
          <QrBoardTitle>
            <h1>{machineName}</h1>
            <h3>
              레인지엑스 앱에서
              <br/>
              QR코드 스캔 또는 숫자코드를 입력하세요.
            </h3>
          </QrBoardTitle>

          <QrCodeBackground>
            <QRCode
              size={256}
              style={{
                height: 'auto',
                maxWidth: '100%',
                width: '100%',
              }}
              value={loginCodeForQr}
              viewBox={`0 0 256 256`}
            />
          </QrCodeBackground>
          <NumberCodeBackground>
            {loginCodeNumber}
          </NumberCodeBackground>
        </QrBoardContents>
        <Button
          size="lg"
          style={{
            backgroundColor: '#171A1F',
            color: '#FFFFFF',
            position: 'absolute',
            bottom: 0,
          }}
          onClick={onClose}
          role="button"
        >
          닫기
        </Button>
      </QrBoardBox>
    </QrBoardContainer>
  )
}
